import React from "react";
import styled from "styled-components";

// asset
import image1 from "assets/img/articleheaderimages/media2.jpg";
import image2 from "assets/img/mediaimages/media3.jpeg";
// import image2 from "assets/img/articleheaderimages/catherine-moran-image-mind-wandering.jpg";
import image3 from "assets/img/articleheaderimages/peter.jpg";
import image4 from "assets/img/articleheaderimages/mark_article.jpg";
import image5 from "assets/img/articleheaderimages/chris_yates.jpg";
import image6 from "assets/img/articleheaderimages/ginni_media.jpg";
import image7 from "assets/img/articleheaderimages/deborah.jpg";

// components
import { Grid } from "@mui/material";
import { ArticlesContainer } from "components/styledsections/ResourcesStyledSections";

const Articles = [
  {
    image: image7,
    isPopular: true,
    category: "Grey Matters",
    date: "June 10, 2025",
    title: "Welcoming Deborah Young to Grey Matters - Ambassador and Agitator!",
    subtitle:
      "We are delighted to welcome Deborah Young MAICD to Grey Matters, a passionate advocate, boundary-breaker, and cross-sector international leader, as our Ambassador and fractional head of Community...",
    articleURL:
      "https://www.linkedin.com/posts/grey-matters-ai_greymatters-longevityleadership-ageinclusion-activity-7337991913523814400-_RIC?utm_source=share&utm_medium=member_desktop&rcm=ACoAACP04dkBtYW1NRzG3kHS3FbSnGHR2C8WzG8",
  },
  {
    image: image5,
    isPopular: true,
    category: "Grey Matters",
    date: "June 5, 2025",
    title:
      "Announcing Dr. Christine Yates as Chair of the Grey Matters Academic Board!",
    subtitle:
      "We are delighted to welcome Dr Christine Yates (Chris) to Grey Matters as the chair of our newly formed Academic Board. Chris’s appointment further supports our mission to harness cutting-edge technology...",
    articleURL:
      "https://www.linkedin.com/posts/grey-matters-ai_greymatters-longevityscience-academicleadership-activity-7336179982328545280-IjNV?utm_source=share&utm_medium=member_desktop&rcm=ACoAACP04dkBtYW1NRzG3kHS3FbSnGHR2C8WzG8",
  },
  {
    image: image6,
    isPopular: true,
    category: "Grey Matters",
    date: "March 13, 2025",
    title: "Announcing Dr. Ginni Mansberg as Grey Matters' new Advisor!",
    subtitle:
      "We are delighted to welcome Dr Ginni Mansberg GAICD to Grey Matters® as our new Advisor, marking a significant milestone in our mission to transform the longevity, health, and wellness landscape.",
    articleURL:
      "https://www.linkedin.com/feed/update/urn:li:activity:7305720505292988416/",
  },
  {
    image: image4,
    isPopular: true,
    category: "Grey Matters",
    date: "February 11, 2025",
    title: "Announcing Mark Fitzgibbon as Grey Matters' New Advisor!",
    subtitle:
      "We are thrilled to welcome Mark Fitzgibbon as our latest Advisor to Grey Matters®, as we continue reimagining retirement and pioneering a transformative longevity experience.",
    articleURL:
      "https://www.linkedin.com/posts/grey-matters-ai_greymatters-longevityeconomy-goinggrey-activity-7294852642768314368-9gbq/?utm_source=share&utm_medium=member_desktop&rcm=ACoAACP04dkBtYW1NRzG3kHS3FbSnGHR2C8WzG8",
  },
  {
    image: image3,
    isPopular: true,
    category: "Grey Matters",
    date: "January 14, 2025",
    title: "Announcing Peter Harmer as Grey Matters' First Advisor!",
    subtitle:
      "We are delighted to welcome Peter Harmer as the first Advisor to Grey Matters®, marking a significant milestone in our mission to transform the longevity, health, and wellness landscape. ",
    articleURL:
      "https://www.linkedin.com/feed/update/urn:li:activity:7284727612092887041",
  },
  {
    image: image1,
    isPopular: false,
    category: "Age-Inclusive",
    date: "October 10, 2024",
    title:
      "Grey Matters and AgeInc announce a partnership to combat age discrimination",
    subtitle:
      "Grey Matters, who help over 45s shape their lives by providing personalised life plans for longevity and ageing well, and AgeInc, the Age Inclusive Employer Endorsement program, proudly announce a new strategic partnership.",
    articleURL:
      "https://getthewordout.com.au/press-release/press-release-in-recognition-of-ageism-awareness-day-grey-matters-and-ageinc-announce-a-partnership-to-combat-age-discrimination-in-the-workplace/",
  },
  {
    image: image2,
    isPopular: false,
    category: "Longevity",
    date: "February 8, 2024",
    title:
      "Grey Matters: New venture led by ex-Publicis Sapient MD aims to navigate the challenges of an ageing population",
    subtitle:
      "Four of the country's top innovation, technology, creative and commercial executives have joined forces on the business.",
    articleURL:
      "https://getthewordout.com.au/press-release/press-release-in-recognition-of-ageism-awareness-day-grey-matters-and-ageinc-announce-a-partnership-to-combat-age-discrimination-in-the-workplace/",
  },
];

export default function Media() {
  return (
    <>
      <Wrapper className="container">
        <VerticalSectionWrapper>
          <Grid
            container
            bgcolor="transparent"
            spacing={4}
            justifyContent="flex-start"
            width="auto"
          >
            {Articles.map((article, index) => (
              <Grid item xs={12} sm={4} key={index}>
                <ArticlesContainer
                  image={article.image}
                  isPopular={article.isPopular}
                  category={article.category}
                  date={article.date}
                  title={article.title}
                  subtitle={article.subtitle}
                  articleURL={article.articleURL}
                />
              </Grid>
            ))}
          </Grid>
        </VerticalSectionWrapper>
      </Wrapper>
    </>
  );
}

const Wrapper = styled.section`
  display: flex;
`;

const VerticalSectionWrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 48px;
  padding-top: 85px;
  padding-bottom: 65px;
`;
